import React, { useEffect, useState } from "react";
import { Radio } from "@mui/material";
import {
	CustomButton,
	InfiniteList2,
	OptionsPanelContainer,
	SidePanel,
	SidePanelContent,
} from "../../../../../../common/components";
import { translate, translateDate } from "../../../../../../common/providers";
import styles from "./AgentSidePanel.module.css";
import FilterHeader from "../FilterHeader";
import { useApi, usePrevious } from "../../../../../../common/hooks";
import { AiAgentsService } from "../../../../../../api";

export default function AgentSidePanel({ agent, open, onClose, onSubmit }) {
	const { call: getDefinitionList } = useApi(AiAgentsService.getDefinitionList);
	const [searchAgentName, setSearchAgentName] = useState("");
	const [infiniteListRequest, setInfiniteListRequest] = useState(null);
	const [tempAgent, setTempAgent] = useState(null);
	const prevAgent = usePrevious(agent);
	useEffect(() => {
		if (prevAgent?.agentId !== agent?.agentId) {
			setTempAgent({ id: agent?.agentId, title: agent?.agentTitle });
		}
	}, [agent, prevAgent]);
	useEffect(() => {
		setInfiniteListRequest(
			() =>
				({ page, limit }) =>
					getDefinitionList({
						titleContains: searchAgentName,
						page,
						size: limit,
						sort: "title;desc",
					})
		);
	}, [searchAgentName, getDefinitionList]);
	const handleChangeFilters = ({ name }) => {
		setSearchAgentName(name);
	};
	const handleSubmit = () => {
		if (typeof onSubmit === "function") {
			onSubmit(tempAgent);
		}
	};
	const handleCheckAgent = (newAgent) => {
		setTempAgent(tempAgent?.id === newAgent?.id ? null : newAgent);
	};
	const rowRenderer = (rowAgent) => (
		<div key={rowAgent.id} className={styles.row}>
			<Radio checked={tempAgent?.id === rowAgent?.id} onClick={() => handleCheckAgent(rowAgent)} />
			<span>{`[${translateDate(rowAgent.created)}]`}</span>
			<span>{rowAgent.title}</span>
		</div>
	);
	return (
		<SidePanel open={open} size={35} onClose={onClose}>
			{({ onActive }) => (
				<SidePanelContent
					className={styles.sidePanel}
					title={translate("dsi.agents.selection.side-panel.title")}
					onActive={onActive}
					onClose={onClose}
				>
					<OptionsPanelContainer className={styles.options__content} mainClassName={styles.option__main}>
						<FilterHeader onChangeFilters={handleChangeFilters} />
						<div className={styles.list}>
							<InfiniteList2 request={infiniteListRequest} rowRenderer={rowRenderer} />
						</div>
					</OptionsPanelContainer>
					<div className={styles.footer}>
						<CustomButton color="primary" variant="contained" onClick={handleSubmit}>
							{translate("common:btn.submit")}
						</CustomButton>
						<CustomButton color="secondary" variant="outlined" onClick={onClose}>
							{translate("common:btn.cancel")}
						</CustomButton>
					</div>
				</SidePanelContent>
			)}
		</SidePanel>
	);
}
